import { useTranslation } from 'react-i18next';
import { Button } from '@treezor/design-system';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { useAccesControl } from '@/hooks/useAccessControl';
import { useAppDispatch } from '@/hooks/redux-helpers';

import { openModal } from '@/store/actions/core.actions';
import { usePaymentCardStatus } from '@/features/cards/hooks/usePaymentCardStatus';
import { allcardStatus, IPaymentCard } from '@/features/cards/store/models/card.model';
import { featuresSlugs } from '@/features/roles/store/models/features.model';

import { ITransactionSimulationModalProps } from '@/features/cards/components/TransactionSimulationModal';

interface ICardTransactionSimulationProps {
  card: IPaymentCard;
}

export function CardTransactionSimulation({ card }: ICardTransactionSimulationProps) {
  const config = useDashboardConfig();
  const { hasAccessToFeature } = useAccesControl();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { status } = usePaymentCardStatus(card);

  const canSimulateTransaction =
    config.site.environment.toLowerCase() === 'sandbox' &&
    hasAccessToFeature(featuresSlugs.SIMULATION) &&
    status === allcardStatus.ACTIVE;

  const toggleSimulateTransactionDialog = () => {
    dispatch(openModal<ITransactionSimulationModalProps>('transactionSimulationModal', { card }));
  };

  if (!canSimulateTransaction) return <></>;

  return (
    <Button
      id="simulate-transaction"
      testId="simulate-transaction"
      variant="secondary"
      size="s"
      onClick={toggleSimulateTransactionDialog}
    >
      {t('pages.currentProfiles.cards.settings.simulation')}
    </Button>
  );
}
